import { Component } from 'react';

/**
 * The card chrome every block on the settings page shares. It reuses the class names the
 * project form's card already carries (`ai-tracking-modal` + `as-page`) so a new block picks
 * up the exact same header, body, footer and dark-mode styling for free.
 *
 * The footer is a two-part bar: a note on the left explaining what saving does, and the
 * card's actions on the right. It sticks to the bottom of the viewport while the body
 * scrolls, so the save action stays reachable on a long card.
 */
class SettingsCard extends Component {
    render() {
        const { title, subtitle, actions, footer, footerNote, children } = this.props;

        return (
            <div className="react-modal as-page ai-tracking-modal edit-project ai-tracking-settings-card">
                {actions && <div className="ai-tracking-settings-card-actions">{actions}</div>}
                <h3>{title}</h3>
                {subtitle && <p className="as-page-subtitle">{subtitle}</p>}
                <div className="ai-tracking-modal-body">{children}</div>
                {(footer || footerNote) && (
                    <div className="ai-tracking-modal-footer ai-tracking-settings-card-footer">
                        <div className="ai-tracking-settings-card-note">
                            {!!footerNote && (
                                <>
                                    <i className="icon-info-circle" />
                                    <span>{footerNote}</span>
                                </>
                            )}
                        </div>
                        <div className="ai-tracking-settings-card-footer-actions">{footer}</div>
                    </div>
                )}
            </div>
        );
    }
}

export default SettingsCard;
